import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';

import { FuseSharedModule } from '@fuse/shared.module';

import { DialogComponent } from "./dialog.component";


@NgModule({
    declarations: [
        DialogComponent
    ],
    imports     : [
        RouterModule,

        MatButtonModule,
        MatIconModule,
        MatToolbarModule,
        MatDialogModule,

        FuseSharedModule
    ],
    exports     : [
        DialogComponent
    ],
    entryComponents: [
        DialogComponent
    ],
})
export class DialogModule
{
}
